import { c as _c } from "react/compiler-runtime";
import { Formik } from 'formik';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { PaymentElement } from '@stripe/react-stripe-js';
import Loading from '../../../../../common/base/Loading';
import Text from '../../../../../common/base/Text';
import { Div } from '../../../../../common/helpers/StyledUtils';
import Modal from '../../../../../common/Modal';
import { useToasts } from '../../../../../common/Toast';
import { GlobalContext } from '../../../../../contexts/GlobalContext';
import WrapWithStripeElement from '../WrapWithStripeElement';
import Sentry from '../../../../../../client/Sentry';
const PaymentMethodModal: React.FC = () => {
  const $ = _c(17);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    addToast
  } = useToasts();
  const history = useHistory();
  let t0;
  if ($[0] !== history) {
    t0 = () => history.push({
      pathname: "/settings/organization/billing",
      state: {
        scroll: false
      }
    });
    $[0] = history;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onClose = t0;
  let t1;
  if ($[2] !== HookdeckAPI || $[3] !== addToast || $[4] !== history) {
    t1 = async confirmCardSetup => {
      ;
      try {
        const payment_method_id = await confirmCardSetup();
        await HookdeckAPI.billing.setPaymentMethodAsDefault(payment_method_id);
        addToast("success", "Payment method updated.");
        history.push("/settings/organization/billing");
      } catch (t2) {
        const err = t2;
        console.error(err);
        Sentry.captureException(err);
        addToast("error", "Something went wrong, please try again or contact us.");
      }
    };
    $[2] = HookdeckAPI;
    $[3] = addToast;
    $[4] = history;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleSubmit = t1;
  let t2;
  if ($[6] !== onClose) {
    t2 = {
      title: "Update payment method",
      cancel_label: "Cancel",
      submit_label: "Confirm",
      onCancel: onClose,
      onClose
    };
    $[6] = onClose;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const modal_props = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Div flex={{
      align: "center",
      justify: "center"
    }} p={{
      t: 8,
      y: 6
    }}><Loading /></Div>;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== modal_props) {
    t4 = <Modal {...modal_props}>{t3}</Modal>;
    $[9] = modal_props;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== handleSubmit || $[12] !== modal_props) {
    t5 = t6 => {
      const {
        confirmCardSetup: confirmCardSetup_0
      } = t6;
      return <Formik initialValues={{
        cc_complete: false
      }} onSubmit={() => handleSubmit(confirmCardSetup_0)} validate={_temp}>{props => <form onSubmit={props.handleSubmit}><Modal {...modal_props} is_submitting={props.isSubmitting}><Div m={{
              b: 0
            }}><PaymentElement onChange={event => props.setFieldValue("cc_complete", event.complete)} options={{
                layout: "tabs",
                paymentMethodOrder: ["card"]
              }} />{props.errors.cc_complete && <Text m={{
                t: 1
              }} danger={true}>{props.errors.cc_complete}</Text>}</Div></Modal></form>}</Formik>;
    };
    $[11] = handleSubmit;
    $[12] = modal_props;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <WrapWithStripeElement loading={t4}>{t5}</WrapWithStripeElement>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default PaymentMethodModal;
function _temp(values) {
  const errors = {};
  if (!values.cc_complete) {
    errors.cc_complete = "Credit card is required";
  }
  return errors;
}